import type { RandomGameBranding } from '../types';
import { DoorReveal } from './DoorReveal';
import styles from './halloween.module.css';

// Trick or Treat: the picker becomes a door that knocks, then swings open on the game.
export const halloween: RandomGameBranding = {
  themeClassName: styles.theme,
  Reveal: DoorReveal,
};
